Date.prototype.getWeek = function() {
    const date = new Date(this);
    date.setHours(0, 0, 0, 0);

    // ISO 8601: Первая неделя года содержит 4 января
    const onejan = new Date(date.getFullYear(), 0, 4);
    const firstThursday = onejan.getTime() - ((onejan.getDay() + 6) % 7) * 86400000;

    return Math.ceil((date - firstThursday) / (7 * 86400000));
};

Date.prototype.get2Weeks = function() {
    return Math.ceil(this.getWeek() / 2);
};